module.exports = __webpack_public_path__ + "static/media/矩形 51@3x.7c6e8e3b.png";